import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  addCourierServiceCostApi,
  deleteCourierServiceCostApi,
  getCourierServiceCostDeliveryPartnersApi,
  getCourierServiceCostsApi,
  updateCourierServiceCostApi,
} from "../../../services/setting/courierServiceCostService";

export const getAllCourierServiceCosts = createAsyncThunk("partner/getAllCourierServiceCosts", async (filters, { dispatch }) => {
  const response = await getCourierServiceCostsApi(filters);
  return response.response;
});

export const getCourierServiceCostDeliveryPartners = createAsyncThunk("partner/getCourierServiceCostDeliveryPartners", async () => {
  const response = await getCourierServiceCostDeliveryPartnersApi();
  return response.response;
});

export const addCourierServiceCost = createAsyncThunk("partner/addCourierServiceCost", async (data, { dispatch, getState }) => {
  try {
    const response = await addCourierServiceCostApi(data);
    const result = await response.response;
    toast.success("Add Courier Service Cost successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return result;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const updateCourierServiceCost = createAsyncThunk("partner/updateCourierServiceCost", async (data, { dispatch, getState }) => {
  try {
    const response = await updateCourierServiceCostApi(data, data.id);
    const result = await response.response;
    toast.success("Update Courier Service Cost successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return result;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const deleteCourierServiceCost = createAsyncThunk("partner/deleteCourierServiceCost", async (id, { dispatch, getState }) => {
  try {
    const response = await deleteCourierServiceCostApi(id);
    const result = await response.response;
    toast.success("Deleted Courier Service Cost successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return result;
  } catch (e) {
    return Promise.reject(e);
  }
});

const courierServiceCostAdapter = createEntityAdapter({});

export const { selectAll: selectCourierServiceCost, selectById: selectCourierServiceCostById } = courierServiceCostAdapter.getSelectors(
  (state) => state.partner.courierServiceCost
);

const courierServiceCostSlice = createSlice({
  name: "courierServiceCost",
  initialState: courierServiceCostAdapter.getInitialState({
    deliveryPartners: [],
    addDialog: {
      component: "CourierServiceCost",
      type: "new",
      props: {
        open: false,
      },
      data: null,
    },
  }),
  reducers: {
    openNewDialog: (state, action) => {
      state.addDialog = {
        component: "CourierServiceCost",
        type: "new",
        props: {
          isOpen: true,
        },
        data: null,
      };
    },
    openEditDialog: (state, action) => {
      state.addDialog = {
        type: "edit",
        props: {
          isOpen: true,
        },
        data: action.payload,
      };
    },
    closeEditDialog: (state, action) => {
      state.addDialog = {
        type: "edit",
        props: {
          isOpen: false,
        },
        data: null,
      };
    },
  },
  extraReducers: {
    [getAllCourierServiceCosts.fulfilled]: courierServiceCostAdapter.setAll,
    [getCourierServiceCostDeliveryPartners.fulfilled]: (state, action) => {
      state.deliveryPartners = action.payload;
    },
  },
});

export const { openNewDialog, openEditDialog, closeEditDialog } = courierServiceCostSlice.actions;

export default courierServiceCostSlice.reducer;
